import { UserAuthorizationType } from '@next-space/fe-api-idl';
import type { FC } from 'react';
import { useEffect, useRef } from 'react';

import { useCheckComplete } from '../../hook/use-check-complete';
import { useThirdPartLogin } from '../../hook/use-third-part-login';
import { Images } from '../../images';
import type { CombineViewProps } from '../../types';
import { AccountStatus, ViewType } from '../../types';
import { randomCode } from '../../utils';
import { loginInjector } from '../../utils/init';

const redirectUrl = `${loginInjector.origin}/auth-callback`;
/**electron专用 */
export const WechatLoginElectron: FC<CombineViewProps> = (props) => {
  const { accountStatus, authorizationCode, tryLogin } = useThirdPartLogin(
    UserAuthorizationType.WECHAT
  );
  const webviewRef = useRef<any>(null);
  const checkComplete = useCheckComplete(props.switchViewType);
  const { switchViewType } = props;

  useEffect(() => {
    switch (accountStatus) {
      case AccountStatus.NEED_BIND_PHONE: {
        if (authorizationCode) {
          switchViewType({
            type: ViewType.BIND_PHONE,
            props: {
              authorization: {
                code: authorizationCode,
                type: UserAuthorizationType.WECHAT,
              },
            },
          });
        }
        break;
      }
      default:
    }
  }, [authorizationCode, props, accountStatus, switchViewType]);

  useEffect(() => {
    const webview = webviewRef.current;
    const ready = () => {
      //修改样式
      void webview?.insertCSS(
        'html,body{ padding: 0px !important; background-color:#FFFFFF !important;  overflow: hidden !important;  } .title { color:black !important;}'
      );
    };
    const message = async () => {
      if (webview?.src.startsWith(redirectUrl)) {
        const url = new URL(webview.src);
        const searchParams = new URLSearchParams(url.search);
        const code = searchParams.get('code');
        const state = searchParams.get('state');
        if (code && state === randomCode) {
          if (props.onAuth) {
            //外部监听了内部就不做处理
            props.onAuth(code);
            return;
          }
          const user = await tryLogin(code, 'web');
          if (!user) return;
          if (!props.complete || checkComplete(user)) {
            props.onSuccess?.(user);
          }
        }
      }
    };
    webview?.addEventListener('dom-ready', ready);
    webview?.addEventListener('did-stop-loading', message);
    return () => {
      webview?.removeEventListener('did-stop-loading', message);
      webview?.removeEventListener('dom-ready', ready);
    };
  }, [checkComplete, props, tryLogin]);

  return (
    <div className="next-modal flex flex-col items-center pb-8">
      {!props.onAuth && (
        <img
          src={Images.IcTitleClose}
          onClick={() => {
            switchViewType({
              type: ViewType.LOGIN,
            });
          }}
          className="mr-4 mt-4 h-5 w-5 self-end cursor-pointer dark:invert"
        />
      )}
      <img src={Images.wechatLogoLogin} className="mt-6" />
      <div id="wechat_login_container" className="mt-6">
        <webview
          className="overflow-hidden"
          ref={webviewRef}
          src={`https://open.weixin.qq.com/connect/qrconnect?appid=${loginInjector.wechatId}&scope=snsapi_login&redirect_uri=${redirectUrl}&state=${randomCode}&login_type=jssdk&self_redirect=true`}
          style={{
            width: '300px',
            height: '410px',
          }}
        />
      </div>
    </div>
  );
};
